import CityPageTemplate from "../city-template/CityPageTemplate";
import { concordNhConfig } from "./data";

export default function ConcordNHPage() {
  return <CityPageTemplate config={concordNhConfig} />;
}